// extracted by mini-css-extract-plugin
export default {"content":"nxQwwie","icon":"kJneVrG","alert":"vwYuA_q","success":"ENw1CfZ","message":"lsWJxZS EVhxZk8 leavesden2","closeContainer":"jxTBKXv","close":"vcYPeSL nJoGg3s"};